import type { CSSProperties, MouseEvent, ReactElement, ReactNode } from 'react';

import type { ModalOptions } from '../Select/types';

export enum MenuItemType {
  MENU,
  DIVIDER,
  SECTION_TITLE,
}

export type MenuItemProps = {
  icon?: ReactElement;
  label: string;
  className?: string;
  onClick?: (e: MouseEvent) => void;
  disabled?: boolean;
  tooltip?: ReactNode;
  hidden?: boolean;
  type?: MenuItemType;
  subMenus?: MenuItemProps[];
  subMenuWidth?: CSSProperties['width'];
  subMenuOptions?: {
    isOpen: boolean;
    openMenu: () => void;
    closeMenu: () => void;
  };
  closeMenu?: () => void;
  key?: number | string;
};

export type MenuProps = {
  anchorRef?: React.RefObject<HTMLDivElement>;
  triggerNode: ReactElement;
  options: MenuItemProps[];
  modalWidth?: CSSProperties['width'];
  menuStyle?: CSSProperties;
  modalOptions?: ModalOptions;
  onAnchorClickAction?: (e: MouseEvent) => void;

  /**
   * @description
   * controlled component props
   */
  isOpen?: boolean;
  openMenu?: () => void;
  closeMenu?: () => void;
};
